import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import Home from './home/Home';
import { EmptyStateOptions, IContent, EventSources, ShopTabsOptions } from 'types';
import CatalogWrapper from './catalog/CatalogWrapper';
import Posts from '../../feed/Posts';
import Reviews from './reviews/reviews/Reviews';
import { EmptyState } from 'components/emptyState';
import ShopSuggestionsSection from 'pages/profilePage/shopSuggestionsSection/ShopSuggestionsSection';
import { ROUTES } from 'constant';
import StickyLayout from 'components/stickyLayout/StickyLayout';
import MojosTab from './mojosTab/MojosTab';

const Content: FC<IContent> = ({
  selectedTab,
  tip,
  vacationDetails,
  userId,
  isShopOwner,
  suggestedShops,
  onSeeAllCatalogClick,
  onReviewsClick,
  onActivitiesClick,
  onFollow,
  postsDetails,
  onAddItemToCatalogClick,
  getUserFeed,
  getUserMojos,
}) => {
  const navigate = useNavigate();

  const onShopClick = (id: string) => {
    navigate(`/${ROUTES.SHOP}/${id}`);
  };

  if (selectedTab === ShopTabsOptions.Home) {
    return (
      <Home
        tip={tip}
        vacationDetails={vacationDetails}
        isShopOwner={isShopOwner}
        onSeeAllCatalogClick={onSeeAllCatalogClick}
        onReviewsClick={onReviewsClick}
        onActivitiesClick={onActivitiesClick}
        onAddItemToCatalogClick={onAddItemToCatalogClick}
      />
    );
  }
  if (selectedTab === ShopTabsOptions.Mojos) {
    return <MojosTab getUserMojos={getUserMojos} userId={userId} />;
  }

  if (selectedTab === ShopTabsOptions.Catalog) {
    return <CatalogWrapper isShopOwner={isShopOwner} />;
  }
  if (selectedTab === ShopTabsOptions.Activity) {
    return (
      <StickyLayout parentScrollerId="content" topOffset={0}>
        <StickyLayout.Content>
          <Posts
            shouldDisplayFeedBubbles={false}
            posts={postsDetails.list}
            hasMore={postsDetails.hasMore}
            isLoading={postsDetails.isLoading}
            selectedFeedBubble={postsDetails.selectedFeedBubble}
            mojoSource={EventSources.Shop}
            scrollerId="content"
            selectedChatId={null}
            emptyState={
              <div className="section">
                <EmptyState type={EmptyStateOptions.ShopActivity} />
              </div>
            }
            getFeed={getUserFeed}
            shouldHideFollowButton
            isCreatePostLoading={false}
          />
        </StickyLayout.Content>
        <StickyLayout.SideMenu>
          <ShopSuggestionsSection
            shops={suggestedShops}
            onFollowToggle={onFollow}
            onShopClick={onShopClick}
          />
        </StickyLayout.SideMenu>
      </StickyLayout>
    );
  }

  return <Reviews />;
};

export default Content;
